/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatorActivationDetailsV3 } from './operatorActivationDetailsV3';
import { CarbonBlackRegionInfoV3 } from './carbonBlackRegionInfoV3';
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';


export interface RansomwareRecoveryActivationDetailsV3 { 
    activation_details?: OperatorActivationDetailsV3;
    activation_status: RansomwareRecoveryDeploymentStatesEnum;
    /**
     * List of Eligible Carbon Black Regions
     */
    carbon_black_region_info: Array<CarbonBlackRegionInfoV3>;
}
export namespace RansomwareRecoveryActivationDetailsV3 {
}


